import { render, staticRenderFns } from "./OutBidNotificationSettings.vue?vue&type=template&id=68b68ecc&"
import script from "./OutBidNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./OutBidNotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports